import ManageUser from '../components/manage-users/formTable/ManageUsers'
import { Home, Login, SSOCallback, Account, PasswordReset, PasswordSuccess, SilentRenewCallback } from '../views'
import ManageCreators from '../components/manage-creators/ManagCreator'
import ManageCompanies from '../components/manage-companies/ManageCompanies'
import ManageApps from '../components/manage-apps/ManageApps'

export const routes = [
    {
        path: '/',
        private: true,
        component: Home,
    },
    {
        path: '/login',
        component: Login,
    },
    {
        path: '/callback',
        component: SSOCallback,
    },
    {
        path: '/silent_renew',
        component: SilentRenewCallback,
    },

    {
        path: '/account',
        private: true,
        component: Account,
    },
    {
        path: '/users',
        private: true,
        adminOnly: true,
        component: ManageUser,
    },
    {
        path: '/creators',
        private: true,
        superUserOnly: true,
        component: ManageCreators,
    },
    {
        path: '/companies',
        private: true,
        adminOnly: true,
        component: ManageCompanies,
    },
    {
        path: '/apps',
        private: true,
        adminOnly: true,
        component: ManageApps,
    },
    {
        path: '/password_reset',
        component: PasswordReset,
    },
    {
        path: '/password_reset/success',
        component: PasswordSuccess,
    },
]
